import { render, staticRenderFns } from "./applicationFormInfo.vue?vue&type=template&id=12b5bd8f&scoped=true&"
import script from "./applicationFormInfo.vue?vue&type=script&lang=js&"
export * from "./applicationFormInfo.vue?vue&type=script&lang=js&"
import style0 from "./applicationFormInfo.vue?vue&type=style&index=0&id=12b5bd8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5bd8f",
  null
  
)

export default component.exports